export const api = {
  // absence-policy
  staffLeaveList: '/api/absence-policy/',
  createLeaveProfile: '/api/absence-policy/create/',
  getAbsencePolicyOption: '/api/absence-policy/option/',
  // absence_balance
  getAbsenceBalance: '/api/absence_balance/my_balance/',
  getBalanceOption: 'api/absence_balance/my_balance_option/',
  // absence_request
  getWorkingDays: 'api/absence_request/calculate_working_days/',
  getAbsenceRequestCalendar: '/api/absence_request/calendar/',
  createAbsenceRequest: '/api/absence_request/create/',
  getListRequestApproval: '/api/absence_request/my_managed/',
  getMyRequest: 'api/absence_request/my_request/',
  getUserWorkshift : 'api/workshift-policy/user_workshift/',
  getUserPublicHoliday : '/api/public_holiday_calendar/user_public_holiday/',
  // absence_type
  getAbsenceTypes: '/api/absence_type/',
  getAllAbsenceTypes: '/api/absence_type/option/',
  createAbsenceType: '/api/absence_type/create/',
  // auth
  login: '/api/auth/login/',
  logOut: '/api/auth/logout/',
  putUserPasswords: '/api/auth/change-password/',
  getToken: '/api/auth/refresh/',
  forceLogin: '/api/auth/force-login/',
  // boarding
  getListBoarding: '/api/boarding/',
  createActiveTask: '/api/boarding/task/create/',
  updateActiveTask: '/api/boarding/task/update/',
  deleteActiveTask: '/api/boarding/task/delete/',
  getAllActiveTask: '/api/boarding/task/',
  // boarding-model
  getBoardingModel: '/api/boarding-model/',
  createModal: '/api/boarding-model/create/',
  getBoardingModelOption: '/api/boarding-model/option/',
  // department
  getDepartment: '/api/department/',
  departmentList: '/api/department/',
  createDepartment: '/api/department/create/',
  // event
  subScribeNoti: '/api/event/subscribe/',
  postEvent: '/api/event/publish/',
  // file
  upload: '/api/file/upload/',
  // public_holiday_calendar
  getPublicHoliday: '/api/public_holiday_calendar/',
  createPublicHoliday: '/api/public_holiday_calendar/create/',
  // service
  getService: '/api/service/',
  createService: '/api/service/create/',
  serviceList: '/api/service/manager/',
  // site_configuration
  getCustomizeConfiguration: '/api/site_configuration/',
  updateCustomizeDesign: '/api/site_configuration/update/',
  // task
  getTasksList: '/api/task/',
  createTask: '/api/task/create/',
  getTasksOption: '/api/task/option/',
  // users
  usersList: '/api/users/',
  register: '/api/users/create/',
  getEmployees: '/api/users/employee/',
  getProfile: '/api/users/info/',
  managerList: '/api/users/manager/',
  getUserPreference: '/api/users/preference/',
  putUserPreference: '/api/users/preference/update/',
  absenceRequestById: '/api/absence_request/my_request',
  existUser: '/api/users/alternative/',
  deleteUser: '/api/users/delete/',
  archiveUser: '/api/users/archive',
  organizationTree: '/api/users/organization_tree/',
  // workshift-policy
  workShiftList: '/api/workshift-policy/',
  createWorkShiftPolicy: '/api/workshift-policy/create/',
  //notification
  get_noti: '/api/notification/',
  get_noti_count: '/api/notification/count/',
  create_noti: '/api/notification/create/',
  delete_noti: '/api/notification/delete/',
  update_noti: '/api/notification/seen/',
  //main-task
  create_main_task: '/api/main_task/create/',
  get_main_task: '/api/main_task/',
  get_task_count: '/api/main_task/count/',
  //forgot password
  send_request: '/api/auth/send-forgot-password/',
  reset_password: '/api/auth/reset-forgot-password/',
  //history
  balance_history:'/api/absence_balance/history/',
  absence_history:'/api/absence_request/my_managed/history/'
};
